import { createContext } from "react"

export const LanguageCtx = createContext({ lang: "hu" })

export const CurrentPathCtx = createContext({ path: "", setPath: () => {} })

export const defaultLang = "hu"

export const extraLanguages = ["en"]
